import { User as FirebaseUser } from "firebase/auth";

export interface FirebaseContextValue {
  firebaseUser: FirebaseUser | null;
  isLoggedIn: boolean;
  isInitialized: boolean;
  isSignInError: boolean;
  signIn: (token: string) => Promise<void> | void;
  signOut: () => void;
}
